var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',_vm._b({style:(`min-height:${_vm.minHeight}px`),attrs:{"id":"instruction_player","width":"100%","height":"100%","src":`${_vm.getYoutubeEmbedLink(_vm.src)}?enablejsapi=1&html5=1&rel=0&autoplay=${_vm.stop ? 0 : 1}&showinfo=0', frameborder='0'`,"allowfullscreen":"","frameBorder":"0"}},'iframe',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }